// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3zgIK","choiceBoxes":"toolbarselects_choiceBoxes__3iN8x","simpleField":"toolbarselects_simpleField__dje-B"};